export var IReactionsMenuParent;
(function (IReactionsMenuParent) {
    IReactionsMenuParent[IReactionsMenuParent["Button"] = 1] = "Button";
    IReactionsMenuParent[IReactionsMenuParent["OverflowMenu"] = 2] = "OverflowMenu";
    IReactionsMenuParent[IReactionsMenuParent["OverflowDrawer"] = 3] = "OverflowDrawer";
})(IReactionsMenuParent || (IReactionsMenuParent = {}));
